export const team = () => {
    const winWidth = window.innerWidth;
    const teamLinks = document.querySelectorAll('.team--item--link');
    const teamModals = document.querySelector('.team--modals');

    // Only proceed if we have people links
    if (teamLinks.length > 0) {
        // Event delegation for grid item clicks
        teamLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const id = e.target.getAttribute('href');
                console.log(id);

                if (teamModals) {
                    teamModals.classList.add('is-open');
                    const targetModal = document.querySelector(id);
                    if (targetModal) {
                        targetModal.classList.add('is-viewing');
                        modalButtons(id);
                    }
                }
            });
        });
    }

    // Close modal handler
    if (teamModals) {
        teamModals.addEventListener('click', (e) => {
            const closeBtn = e.target.closest('.team--modal__close');
            if (!closeBtn) return;

            e.preventDefault();
            teamModals.classList.remove('is-open');
            document.querySelectorAll('.team--modal').forEach(modal => modal.classList.remove('is-viewing'));
        });
    }

    // Modal navigation buttons handler
    // document.querySelector('.people--modals__button').addEventListener('click', (e) => {
    //     e.preventDefault();
    //     const id = e.target.getAttribute('href');

    //     document.querySelectorAll('.people--modal').forEach(modal => modal.classList.remove('is-viewing'));
    //     document.querySelector(id).classList.add('is-viewing');

    //     modalButtons(id);
    // });

    function modalButtons(id) {
        const teamGrid = document.querySelector('.team--grid');
        const currentModal = document.querySelector(id);

        if (!currentModal) return;

        const isFiltered = teamGrid ? teamGrid.classList.contains('is-filtered') : false;
        const parent = document.querySelector('#' + currentModal.getAttribute('data-parentid'));

        if (!parent) return;

        // Get previous and next items
        const prev = parent.previousElementSibling;
        const next = parent.nextElementSibling;

        // Get first and last modals
        const modals = document.querySelectorAll('.team--modal');
        if (modals.length === 0) return;

        const first = modals[0];
        const last = modals[modals.length - 1];

        // Get navigation elements
        const prevBtn = document.querySelector('#team--modals__prev');
        const nextBtn = document.querySelector('#team--modals__next');

        if (!prevBtn || !nextBtn) return;

        if (prev || next) {
            // Handle previous button
            if (prev && !prev.classList.contains('is-hiding')) {
                prevBtn.setAttribute('href', '#' + prev.getAttribute('data-link'));
                prevBtn.textContent = prev.getAttribute('data-name');
                prevBtn.style.display = 'block';
            } else {
                prevBtn.setAttribute('href', '#' + last.id);
                prevBtn.textContent = last.getAttribute('data-name');
                prevBtn.style.display = 'block';
            }

            // Handle next button
            if (next && !next.classList.contains('is-hiding')) {
                nextBtn.setAttribute('href', '#' + next.getAttribute('data-link'));
                nextBtn.textContent = next.getAttribute('data-name');
                nextBtn.style.display = 'block';
            } else {
                nextBtn.setAttribute('href', '#' + first.id);
                nextBtn.textContent = first.getAttribute('data-name');
                nextBtn.style.display = 'block';
            }
        } else {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
        }
    }
}
